// extracted by mini-css-extract-plugin
export var label = "_ho-0";
export var treatmentCard = "_ho-1";